import { cn } from "@/utils/theme";
import type { ComponentProps } from "react";

interface Props {
  children?: React.ReactNode;
}

const CardFallback = ({
  children,
  className,
  ...props
}: Props & ComponentProps<"div">) => {
  return (
    <div
      className={cn(
        "shadow-none bg-neutral-object-accent-silent border border-neutral py-3 px-4 rounded-lg",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default CardFallback;
